import employeeService from "@/api/employeeService";

export default {
    async allEmployees() {
        let all = {'id': '', 'name': 'All Employees'};
        let employees = await employeeService.getEmployees();
        employees = employees.map(employee => {
            return {
                ...employee,
                name: `${employee.first_name} ${employee.middle_name} ${employee.last_name}`
            };
        });
        employees.unshift(all)
        return employees
    }
}
